import React from 'react';

interface RadialProgressProps {
    currentStep: number;
    totalSteps: number;
    size?: number;
    strokeWidth?: number;
    color?: string;
}

export function RadialProgress({
    currentStep,
    totalSteps,
    size = 60,
    strokeWidth = 4,
    color = '#1cb0f6'
}: RadialProgressProps) {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const progress = currentStep / totalSteps;
    const strokeDashoffset = circumference - progress * circumference;

    return (
        <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
            {/* Background Circle */}
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                className="transform -rotate-90"
            >
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="#e5e7eb"
                    strokeWidth={strokeWidth}
                />
                {/* Progress Circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    className="transition-all duration-500 ease-out"
                />
            </svg>

            {/* Text */}
            <div className="absolute flex flex-col items-center justify-center text-xs font-bold text-gray-700">
                <span>{currentStep} of {totalSteps}</span>
            </div>
        </div>
    );
}
